class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  min_gift_product() {
    console.log('test');
   if(!window.cartStrings.variant) return;
    fetch(`${window.routes.cart_url}` + ".js")
      .then((response) => response.json())
      .then((data) => {
        var freeProductId = window.cartStrings.variant.trim(),
          min_gift_val = parseInt(window.cartStrings.amount.trim()) * 100,
          cartTotal = data.total_price,
          add_gift = false;
          for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].id == freeProductId && data.items[i].properties?._min_gift == 'true') {
              add_gift = true;
            }
          }
        if (parseInt(cartTotal) > min_gift_val && add_gift == false) {
          // console.log("eligible-product");
          fetch(`${window.routes.cart_add_url}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: freeProductId,
              quantity: 1,
              "properties": {
                _min_gift: "true"
              }
            }),
          })
            .then((response) => response.text())
            .then((html) => {
              fetch(this.dataset.url)
                .then((response) => response.text())
                .then((html) => {
                  document.getElementById("mini-cart").innerHTML =
                    this.getSectionInnerHTML(html, ".shopify-section");
                })
                .catch((e) => {
                  console.error(e);
                });
            });
        } else if (parseInt(cartTotal) < parseInt(min_gift_val) && add_gift == true) {
          console.log("remove call");
          if (document.querySelector('cart-items li[data-variant-id="' + freeProductId + '"]')) {
            document.querySelector("cart-items").updateQuantity(
              document.querySelector(
                'cart-items li[data-variant-id="' + freeProductId + '"]'
              ).dataset.index,
              0
            );
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

customElements.define('mini-cart', MiniCart);
